import { z } from 'zod';

export const AdminGateActionSchema = z.enum(['ENTRY', 'EXIT', 'REENTRY', 'OVERRIDE']);
export type AdminGateAction = z.infer<typeof AdminGateActionSchema>;

export const AdminGateConfigTypeSchema = z.enum(['ENTRY_ONLY', 'EXIT_ONLY', 'ENTRY_EXIT']);
export type AdminGateConfigType = z.infer<typeof AdminGateConfigTypeSchema>;

export const AdminGateScanEventSchema = z.object({
  gateId: z.string(),
  action: AdminGateActionSchema,
  valid: z.boolean(),
  message: z.string(),
  scannerId: z.string(),
  ticketId: z.string().optional(),
  customerName: z.string().optional(),
  ticketType: z.string().optional(),
  entryCount: z.number().int().optional(),
  maxEntries: z.number().int().optional(),
  denialReason: z.string().optional(),
  denialCode: z.string().optional(),
  capacityInfo: z
    .object({
      currentOccupancy: z.number().int(),
      maxCapacity: z.number().int(),
      status: z.string(),
    })
    .optional(),
  timestamp: z.string(),
});
export type AdminGateScanEvent = z.infer<typeof AdminGateScanEventSchema>;

export const AdminGateEntitySchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  type: AdminGateConfigTypeSchema,
  isActive: z.boolean(),
});
export type AdminGateEntity = z.infer<typeof AdminGateEntitySchema>;

export const AdminGateOverrideSchema = z.object({
  scannerId: z.string(),
  qrContent: z.string(),
  action: z.enum(['FORCE_ENTRY', 'FORCE_EXIT', 'FORCE_REENTRY']),
  staffId: z.string(),
  reason: z.string().min(1).max(500),
  notes: z.string().max(1000).optional(),
});
export type AdminGateOverrideInput = z.infer<typeof AdminGateOverrideSchema>;
